import { render, staticRenderFns } from "./VerifyAccount.vue?vue&type=template&id=2e514c33&"
import script from "./VerifyAccount.vue?vue&type=script&lang=js&"
export * from "./VerifyAccount.vue?vue&type=script&lang=js&"
import style0 from "./VerifyAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports